<template>
    <div class="formBox">
        <div class="initiateBox">
            <h4>发起签约</h4>
            <p></p>
        </div>
        <div class="contractContent">
            <p>合同信息</p>
        </div>
        <div class="contentBox">
            <div style="width: 80%">
                <el-form ref="item" :model="item"  v-for="(item, index) in formData" :key="index">
                    <!--                普通输入框-->
                    <el-form-item :label="item.componentName" v-if="item.componentType==1"  :rules="[{ required: item.required, trigger: 'blur' },]">
                        <el-input v-model="item.componentValue" placeholder="请输入内容" :ref="item.componentId" :maxlength="item.componentMaxLength" show-word-limit></el-input>
                    </el-form-item>
                    <!--                数字整数-->
                    <el-form-item :label="item.componentName" v-if="item.componentType==2&&item.numberFormat==0" :rules="[{ required: item.required, trigger: 'blur' },]">
                        <el-input v-model="item.componentValue" onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')" placeholder="请输入内容" :maxlength="item.componentMaxLength" show-word-limit></el-input>
                    </el-form-item>
                    <!--                数字小数点后一位小数-->
                    <el-form-item :label="item.componentName" v-if="item.componentType==2&&item.numberFormat==1" :rules="[{ required: item.required, trigger: 'blur' },]">
                        <el-input v-model="item.componentValue" onkeyup="this.value=this.value.match(/\d+\.?\d{0,1}/);this.dispatchEvent(new Event('input'))" placeholder="请输入内容" :maxlength="item.componentMaxLength" show-word-limit></el-input>
                    </el-form-item>
                    <!--                数字小数点后两位小数-->
                    <el-form-item :label="item.componentName" v-if="item.componentType==2&&item.numberFormat==2" :rules="[{ required: item.required, trigger: 'blur' },]">
                        <el-input v-model="item.componentValue" onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/);this.dispatchEvent(new Event('input'))" placeholder="请输入内容" :maxlength="item.componentMaxLength" show-word-limit></el-input>
                    </el-form-item>
                    <!--                日期-->
                    <el-form-item :label="item.componentName" v-if="item.componentType==3" :rules="[{ required: item.required, trigger: 'blur' },]">
                        <el-date-picker
                                v-model="item.componentValue"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <!--                多选输入框-->
                    <el-form-item :label="item.componentName" v-if="item.componentType==8" :rules="[{ required: item.required, trigger: 'blur' },]">
                        <el-input type="textarea" placeholder="请输入内容" v-model="item.componentValue" :maxlength="item.componentMaxLength" show-word-limit></el-input>
                    </el-form-item>
                    <!--                多选-->
                    <el-form-item :label="item.componentName" v-if="item.componentType==9" :rules="[{ required: item.required, trigger: 'blur' },]">
                        <div v-for="(i,y) in item.options" :key="y">
                            <el-checkbox :label="i.optionOrder" v-model="item.componentValue">{{i.optionContent}}</el-checkbox>
                        </div>
                    </el-form-item>
                    <!--                单选-->
                    <el-form-item :label="item.componentName" v-if="item.componentType==10" :rules="[{ required: item.required, trigger: 'blur' },]">
                        <div v-for="(i,y) in item.options" :key="y">
                            <el-radio  :label="i.optionOrder" v-model="item.componentValue">{{i.optionContent}}</el-radio>
                        </div>
                    </el-form-item>
                    <!--                下拉框-->
                    <el-form-item :label="item.componentName" v-if="item.componentType==14" :rules="[{ required: item.required, trigger: 'blur' },]">
                        <el-select v-model="item.componentValue" placeholder="请选择活动区域" >
                            <el-option :label="i.optionContent" :value="i.optionOrder" v-for="(i,y) in item.options" :key="y"></el-option>
                        </el-select>
                    </el-form-item>
                    <!--                勾选框-->
                    <el-form-item :label="item.componentName" v-if="item.componentType==15" :rules="[{ required: item.required, trigger: 'blur' },]">
                        <el-checkbox v-model="item.componentValue"></el-checkbox>
                    </el-form-item>
                    <!--                身份证-->
                    <el-form-item :label="item.componentName" v-if="item.componentType==16" :rules="[{ required: item.required, trigger: 'blur' },]">
                        <el-input v-model="item.componentValue" placeholder="请输入内容" :maxlength="18" show-word-limit></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div style="display: flex;justify-content: center">
                <el-button class="customize" @click="dialogVisible=true">保存草稿</el-button>
                <el-button class="customize" @click="saveBtn">下一步</el-button>
            </div>

        </div>
        <el-dialog
                title="提示"
                :visible.sync="dialogVisible"
                :close-on-click-modal ="false"
                width="30%">
            <el-form ref="form" :model="ruleForm" >
                <el-form-item label="备注" label-width="80px">
                    <el-input v-model="ruleForm.name" ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="draftBtn">确 定</el-button>
                </span>
        </el-dialog>
    </div>

</template>

<script>
    import { interfaceSave, saveDraft, submitData, templateDetails } from '../../../api/templateList';

    export default {
        name: 'draftPage',
        data(){
            return{
                form:{
                    multiple:''
                },
                formData:{},
                platformNumber:'',
                dialogVisible:false,
                ruleForm:{
                    name:''
                },
                mode:'',
            }
        },
        created() {
            this.mode=JSON.parse(sessionStorage.getItem('shenfen')).mode
            templateDetails(this.$route.query.id).then(res=>{
                this.formData=JSON.parse(sessionStorage.getItem('xinxi'))
            })

        },
        methods:{
            //下一步
            saveBtn(){
                let len=this.formData.length
                for (let i=0;i<len;i++){
                    if (this.formData[i].componentType==15 && this.formData[i].required  && !this.formData[i].componentValue){
                        return  this.$message.error(this.formData[i].componentName+'为必填项')
                    }else if (this.formData[i].componentType==9 && this.formData[i].required  && this.formData[i].componentValue.length==0){
                        return   this.$message.error(this.formData[i].componentName+'为必填项')
                    }else if(this.formData[i].required==true&&this.formData[i].componentValue===''){
                        return   this.$message.error(this.formData[i].componentName+'为必填项')
                    }
                }
                //保存
                submitData(this.$route.query.customBizNum,this.formData).then(res=>{
                    if (res.code==200){
                        this.platformNumber=res.data.customBizNum
                        this.$message.success(res.msg)
                        if (this.mode==1){
                            this.$router.push({path:'signatureInformation',query:{customBizNum:this.$route.query.customBizNum,id:this.$route.query.id}})
                        }else {
                            this.$router.push({path:'/formInformationpay',query:{customBizNum:this.platformNumber,id:this.$route.query.id}})
                        }
                        // sessionStorage.setItem('xinxi',JSON.stringify( res.data ))
                    }else {
                        return  this.$message.error(res.msg)
                    }
                })
            },
            //保存草稿
            draftBtn(){
                saveDraft(this.$route.query.id,this.ruleForm.name,this.formData).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg)
                        this.dialogVisible=false
                    }else {
                        this.$message.error(res.msg)
                        this.dialogVisible=false

                    }
                })
            }
        }
    };
</script>

<style scoped>
    .formBox{
        background-color: #fff;
        border-radius: 5px;
        padding: 30px;
    }
    .initiateBox>h4{
        width: 80px;
        color: #3e60f5;
        text-align: center;
        margin-bottom: 8px;
    }
    .initiateBox>p{
        border-bottom: 2px solid #3e62f6;
        width: 80px;
    }
    .contractContent{
        width: 150px;
        margin-top: 30px;
        border-radius: 5px;
        border: 1px solid #3e62f6;
        text-align: center;
    }
    .contractContent>p{
        padding: 10px;
        color: #3e62f6;
    }
    .contentBox{
        margin: 30px 50px;
        border: 1px solid #f3f2f8;
        border-radius: 5px;
        padding: 30px;
    }

    /deep/.el-select{
        width: 100%;
    }
    /deep/.el-form-item{
        display: flex;
        align-items: center;
    }
    /deep/.el-form-item__content{
        width: 30%;
        flex-direction: column;
    }
    /deep/.el-form-item__content{
        display: flex;
    }
    /deep/.el-form-item__label{
        width: 30%;
    }
    /deep/.el-form-item__content{
        width: 70%;
    }
    /deep/.el-date-editor{
        width: 100%;
    }
    .customize{
        background-color: #3e62f6;
        color: #fff;
        display: block;
    }
    /deep/.el-form-item__content{
        margin-left: 0px !important;
    }
</style>
